import { Wordmark } from '@/components/common/Wordmark';

interface SplitFiestaLoadingProps {
  message?: string;
  className?: string;
}

export function SplitFiestaLoading({
  message,
  className = 'min-h-screen',
}: SplitFiestaLoadingProps) {
  const hasTransparent = className?.includes('bg-transparent');
  const bgClasses = hasTransparent ? '' : 'bg-canvas dark:bg-canvas-dark';

  return (
    <div
      className={`${bgClasses} flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div className="loading-spinner-dark w-10 h-10 mx-auto mb-3"></div>
        <h1 className="flex justify-center">
          <Wordmark height={28} pulse />
        </h1>
        {message && (
          <p className="text-gray-600 dark:text-gray-300 text-sm font-medium mt-3">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
